import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { AddEditUserActionsModalComponent } from 'src/app/pages/mission-control-page/usermanagement-page/add-edit-user-actions-modal/add-edit-user-actions-modal.component';

@Injectable({
  providedIn: 'root'
})
export class AddEditUserActionsModalService {

  addEditUserActionsModal!: BsModalRef;

  constructor(private bsModalService: BsModalService) { }

  show(modalData: any): void {
    const config = new ModalConfig();
    config.class = 'modal-lg custom-ngx-modal';
    config.initialState = modalData;
    config.ignoreBackdropClick = true;
    this.addEditUserActionsModal = this.bsModalService.show(AddEditUserActionsModalComponent, config);
  }
}
